import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MagentoCategoryItem } from 'lib/types'
import { Slice } from './types'
import { PWAThunk } from 'lib/core/data'

export const initialState: Slice = {
  isFetching: false,
  isSuccess: false,
  isFailure: false,
  payload: []
}

const slice = createSlice({
  name: 'common/categoryList',
  initialState,
  reducers: {
    request (state) {
      state.isFetching = true
    },

    success (state, action: PayloadAction<MagentoCategoryItem[]>) {
      state.isFetching = false
      state.isSuccess = true
      state.isFailure = false
      state.payload = action.payload
    },

    failure (state) {
      state.isFetching = false
      state.isSuccess = false
      state.isFailure = true
      state.payload = initialState.payload
    }
  }
})

export const reducer = slice.reducer

export const { request, success, failure } = slice.actions

export function fetchCategoryList (): PWAThunk {
  return async (dispatch, getState, params) => {
    const { magentoClient } = params
    dispatch(request())
    try {
      const response = await magentoClient.getClient().catalog.fetchCategoryList()
      const { data } = response.data || {}
      const { getCategoryList } = data || {}

      if (getCategoryList) {
        dispatch(success(getCategoryList.items))
      } else {
        dispatch(failure())
      }

      return response
    } catch (e) {
      dispatch(failure())
    }
  }
}
